/**
 * Hook zum Laden aller Anlagen eines Projekts (reine Anzeige).
 * Schlanke Alternative zu useGenerationUnitsData — kein CRUD, kein Error-State.
 */
import { useState, useEffect, useCallback } from 'react';
import { generationUnitsApi } from '../../../services/api/generationUnits';
import { GenerationUnit } from '../../../types';

export function useProjectAnlagen(projectId: string | undefined) {
  const [anlagen, setAnlagen] = useState<GenerationUnit[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!projectId) return;
    setLoading(true);
    try {
      const data = await generationUnitsApi.getProjectGenerationUnits(projectId);
      setAnlagen(data ?? []);
    } catch {
      setAnlagen([]);
    } finally {
      setLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    if (!projectId) {
      setLoading(false);
      return;
    }
    load();
  }, [projectId, load]);

  /** Aktualisiert Koordinaten einer Anlage lokal (kein API-Call, kein Reload) */
  const patchPosition = useCallback((unitId: string, breitengrad: number, laengengrad: number) => {
    setAnlagen(prev => prev.map(a =>
      a.id === unitId ? { ...a, breitengrad, laengengrad } : a
    ));
  }, []);

  return { anlagen, loading, reload: load, patchPosition };
}
